import {inject, Injectable} from '@angular/core';
import {BaseApiService} from "./base-api.service";

@Injectable({
  providedIn: 'root'
})
export class ModelsService {
  private readonly apiService = inject(BaseApiService);

  async getModels() {
    return await this.apiService.get('/model/models');
  }

  async getMakes() {
    return await this.apiService.get('/model/makes');
  }

  async getTypes() {
    return await this.apiService.get('/model/types');
  }

  async getModelsByLookup(lookup: string, assetId: string) {
    const body = {
      lookup: lookup,
      assetId: assetId == "0" || !assetId ? null : assetId,
    }
    return await this.apiService.post(`/model/models/lookup`, body);
  }

  async getMakesByLookup(lookup: string, assetId: string) {
    const body = {
      lookup: lookup,
      assetId: assetId == "0" || !assetId ? null : assetId,
    }
    return await this.apiService.post(`/model/makes/lookup`, body);
  }

  async getTypesByLookup(lookup: string, assetId: string) {
    const body = {
      lookup: lookup,
      assetId: assetId == "0" || !assetId ? null : assetId,
    }
    return await this.apiService.post(`/model/types/lookup`, body);
  }
}
